const CATALOG_ITEM_KIND_REPLACEMENTS = [
    [/\bfcu_primary\b/gi, "Fan-coil controller"],
    [/\bheat_only_710\b/gi, "Heat-only controller"],
    [/\bmz_overflow\b/gi, "Overflow zone controller"],
    [/\blocal_ui_ts4\b/gi, "Local room screen"],
    [/\bcentral_control_screen_ts7\b/gi, "Central control screen"],
    [/\bcontrol_temperature_sensor\b/gi, "Control temperature sensor"],
    [/\bufh_limit_sensor_active\b/gi, "Underfloor heating limit sensor"],
    [/\bufh_limit_sensor_spare\b/gi, "Spare underfloor heating limit sensor"],
    [/\bsupply_air_off_coil_sensor\b/gi, "Supply-air sensor"],
    [/\bio_module\b/gi, "I/O module"],
    [/^relay$/i, "Load relay"],
    [/^netmaster$/i, "Netmaster apartment hub"],
    [/\bedge_network_switch\b/gi, "Edge gateway"],
    [/\bedge_compute\b/gi, "Edge gateway"],
    [/\bedge_enclosure\b/gi, "Edge gateway"],
    [/\bnetwork_switch\b/gi, "Network switch"],
    [/^panel$/i, "Control panel enclosure"],
    [/\bcloud_service\b/gi, "Edge gateway"]
];
const CATALOG_ITEM_KIND_DEDUPE = [
    [/\bFan-coil controller\s+fan coil controller\b/gi, "Fan-coil controller"],
    [/\bHeat-only controller\s+heat only controller\b/gi, "Heat-only controller"],
    [
        /\bOverflow zone controller\s+overflow zone controller\b/gi,
        "Overflow zone controller"
    ],
    [/\bLocal room screen\s+local room screen\b/gi, "Local room screen"],
    [/\bCentral control screen\s+central control screen\b/gi, "Central control screen"],
    [
        /\bControl temperature sensor\s+control temperature sensor\b/gi,
        "Control temperature sensor"
    ],
    [
        /\bUnderfloor heating limit sensor\s+underfloor heating limit sensor\b/gi,
        "Underfloor heating limit sensor"
    ],
    [
        /\bSpare underfloor heating limit sensor\s+spare underfloor heating limit sensor\b/gi,
        "Spare underfloor heating limit sensor"
    ],
    [/\bSupply-air sensor\s+supply air sensor\b/gi, "Supply-air sensor"],
    [/\bI\/O module\s+io module\b/gi, "I/O module"],
    [/\bLoad relay\s+load relay\b/gi, "Load relay"],
    [
        /\bNetmaster apartment hub\s+netmaster apartment hub\b/gi,
        "Netmaster apartment hub"
    ],
    [/\bEdge gateway\s+edge gateway\b/gi, "Edge gateway"],
    [/\bNetwork switch\s+network switch\b/gi, "Network switch"],
    [/\bControl panel enclosure\s+control panel enclosure\b/gi, "Control panel enclosure"]
];
const GENERIC_CATALOG_ITEM_KIND_TOKEN = /\b[a-z][a-z0-9]*(?:_[a-z0-9]+)+\b/g;
const CATALOG_ITEM_KIND_WORD_LABELS = {
    bacnet: "BACnet",
    bms: "BMS",
    fcu: "FCU",
    io: "I/O",
    ip: "IP",
    modbus: "Modbus",
    rtu: "RTU",
    ui: "UI"
};
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const genericCatalogItemLabel = (slug) => slug
    .split("_")
    .map((part, index) => {
    const knownLabel = CATALOG_ITEM_KIND_WORD_LABELS[part];
    if (knownLabel) {
        return knownLabel;
    }
    return index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part;
})
    .join(" ");
const collapseGenericCatalogItemDedupe = (value, labels) => labels.reduce((current, label) => {
    const lowerPhrase = label.toLowerCase().split(/\s+/).map(escapeRegExp).join("\\s+");
    const pattern = new RegExp(`\\b${escapeRegExp(label)}\\s+${lowerPhrase}\\b`, "gi");
    return current.replace(pattern, label);
}, value);
export const humaniseCatalogItemText = (value) => {
    const cleaned = (value ?? "").trim();
    if (!cleaned) {
        return "";
    }
    const replaced = CATALOG_ITEM_KIND_REPLACEMENTS.reduce((current, [pattern, replacement]) => current.replace(pattern, replacement), cleaned);
    const deduped = CATALOG_ITEM_KIND_DEDUPE.reduce((current, [pattern, replacement]) => current.replace(pattern, replacement), replaced);
    const genericLabels = new Set();
    const genericReplaced = deduped.replace(GENERIC_CATALOG_ITEM_KIND_TOKEN, (match) => {
        const label = genericCatalogItemLabel(match);
        genericLabels.add(label);
        return label;
    });
    return collapseGenericCatalogItemDedupe(genericReplaced, [...genericLabels])
        .replace(/\s+/g, " ")
        .trim();
};
//# sourceMappingURL=catalogDisplay.js.map